import React from "react";

import { Form, Input, Button, Col, Row } from "antd";
import { v4 as uuidv4 } from "uuid";

function Emails({ emails, setEmails }) {
  const addEmail = () => {
    const newEmail = {
      id: uuidv4(),
      email: "",
    };
    setEmails([...emails, newEmail]);
  };

  const removeEmail = (id) => {
    const updatedEmails = emails.filter((item) => item.id !== id);
    setEmails(updatedEmails);
  };

  const handleChange = (value, name, id) => {
    const updatedEmails = emails.map((item) => {
      if (item.id === id) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setEmails(updatedEmails);
  };

  return (
    <ul>
      {emails.map((item, index) => (
        <li key={item.id}>
          <Form.Item label=" ">
            <Row>
              <Col span={23}>
                <Form.Item
                  label=" "
                  name={`email${index}`}
                  rules={[
                    {
                      required: true,
                      type: "email",
                      message: "please input a valid E-mail!",
                    },
                  ]}
                >
                  <Input
                    placeholder="Emails"
                    onChange={(e) =>
                      handleChange(e.target.value, "email", item.id)
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={1}>
                {emails.length > 1 ? (
                  <Button
                    className="roundSmallButton"
                    onClick={() => {
                      removeEmail(item.id);
                    }}
                    type="primary"
                    shape="circle"
                    icon={<i className="fa-sharp fa-solid fa-xmark"></i>}
                    size={"small"}
                  />
                ) : (
                  <></>
                )}
              </Col>
            </Row>
          </Form.Item>
        </li>
      ))}

      <Form.Item label=" ">
        <Button
          className="addPropertyGroupButton"
          type="primary"
          onClick={addEmail}
          size={"small"}
          icon={<i className="fa-solid fa-circle-plus"></i>}
        >
          {" "}
          Add Another Email
        </Button>
      </Form.Item>
    </ul>
  );
}

export default Emails;
